module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-toggle-button",
    class: [{
      'is-checked': _vm.isChecked
    }, _vm.color]
  }, [_c('ui-button', {
    attrs: {
      "type": "normal",
      "button-type": "button",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-184c06c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIToggleButton.vue
// module id = 291
// module chunks = 2